import styled, { createGlobalStyle } from "styled-components";
import { colors, media, breakpoints } from "../../components/common/mixins";
import olympiacosBg from "../../assets/images/olympiacos-bg.jpg";

export const OlympiacosScopedGlobalStyle = createGlobalStyle`
    #main-wrapper {
      padding: 0;
      margin-bottom: 0;
    }

    #main-wrapper * {
      font-family: inherit;
    }
`;

export const ContentSection = styled.div`
  position: relative;

  &::before {
    content: "";
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100vw;
    left: 0;
    background: url(${olympiacosBg}) center top / cover no-repeat;
    background-attachment: fixed;
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const HeroBanner = styled.div`
  position: relative;
  height: 262px;

  ${media.below(breakpoints.mobile)} {
    height: 290px;
  }
`;

export const HeroBannerMedia = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
`;

export const HeroBannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const HeroBannerGradient = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 1) 1%,
    rgba(0, 0, 0, 0.5) 55%,
    rgba(0, 0, 0, 0) 70%
  );

  ${media.below(breakpoints.mobile)} {
    background: linear-gradient(
      0deg,
      #000 20%,
      rgba(0, 0, 0, 0.6) 38%,
      rgba(0, 0, 0, 0) 65%
    );
  }
`;

export const HeroBannerTextOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  z-index: 1;

  ${media.below(breakpoints.mobile)} {
    align-items: flex-end;
    padding-bottom: 24px;
  }
`;

export const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${media.below(breakpoints.mobile)} {
    gap: 4px;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  margin: 0;

  ${media.below(breakpoints.mobile)} {
    font-size: 16px;
  }
`;

export const SubTitle = styled.h2`
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  margin: 0;

  ${media.below(breakpoints.mobile)} {
    font-size: 16px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
`;

export const EventsGrid = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  grid-template-columns: 1fr;

  ${media.above(breakpoints.mobile)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.above(breakpoints.tablet)} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.above(breakpoints.desktop)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const EventsContainer = styled.div`
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const EventsTitle = styled.h3`
  font-size: 24px;
  line-height: normal;
  margin: 0;

  ${media.below(breakpoints.mobile)} {
    font-size: 16px;
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  padding: 16px 16px 16px 12px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid var(--Colors-grey-grey-600, #d8dbe0);
  background: #fff;
  margin-bottom: 50px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const InfoHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: normal;

  a {
    color: ${colors.darkText};
    font-weight: 600;
    text-decoration-line: underline;
  }

  ${media.below(breakpoints.mobile)} {
    font-size: 12px;
  }
`;

export const TextBold = styled(Text)`
  font-weight: 600;
`;

export const BulletText = styled(Text)`
  padding-left: 12px;
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    left: 0;
  }
`;

export const Link = styled.a`
  color: ${colors.darkText};
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;

  ${media.below(breakpoints.mobile)} {
    font-size: 12px;
  }
`;
